import { WidgetDefinition } from '../models/WidgetDefinition';
import { DataFormat } from '../../framework/charting/charts/DataFormat';
import { GaugeOptions } from '../../framework/charting/charts/Gauge/GaugeOptions';
import { GaugeHelper } from '../../common/helpers/gauge.helper';
import { GaugeDataFormat } from '../../framework/charting/charts/Gauge/GaugeDataFormat';

export const GaugeChartDefinition: WidgetDefinition = {
    baseType: 'gaugeChart',
    group: 'Charts',
    hasImage: true,
    highlights: ['A list of gauge charts with optional target and ranges'],
    icon: 'fa-tachometer',
    sortingOrder: 600,
    title: 'Gauge chart',
    type: 'gaugeChart'
};

export const defaultGaugeChartConfig: { dataFormat: DataFormat<any, any>; options: GaugeOptions; value: GaugeDataFormat } = {
    dataFormat: {
        label: d => d.builtName,
        identifier: d => d.valueType + d.guid,
        value: d => d.value
    },
    options: {
        ticksCount: 6,
        labelsCount: 6,
        thickness: .25,
        range: [-2 * Math.PI / 3, 2 * Math.PI / 3],
        tickSize: 5,
        isLegendVisible: false,
        isTitleVisible: false,
        title: undefined,
        showTarget: false
    },
    value: {
        value: 0,
        format: '.0%',
        bands: GaugeHelper.getDefaultBands(),
        serie: undefined
    }
};